

import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; 


const baseURL = `${process.env.REACT_APP_API_URL}/api`;

const api = axios.create({
  baseURL,
});

// Interceptor para inyectar el token en todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
          console.log("Token expirado, redirigiendo a login");
          localStorage.removeItem('token');
          window.location.href = '/login';
          return Promise.reject('Token expirado');
        }
        config.headers['Authorization'] = `Bearer ${token}`;
        console.log('🔐 Token enviado en petición:', config.url);
      } catch (error) {
        console.error('Error al verificar el token', error);
        localStorage.removeItem('token');
        window.location.href = '/login';
        return Promise.reject('Token inválido');
      }
    } else {
      console.log('⚠️ No hay token disponible');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas de error
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log("Error 401 - Token inválido, redirigiendo a login");
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
